import { ServerFetch } from '../main-model'

export default class QuotationListModel extends ServerFetch {
    getQuotationListBy = (data) => this.authFetch({
        url: 'quotation-list/getQuotationListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}